// This file is auto-generated from lib/productsService/data/products.csv
// Do not edit this file directly

export const PRODUCTS = {
  "Red Hat Enterprise Linux": {
    "Full Support": "FULL_SUPPORT",
    "Maintenance Phase": "MAINTENANCE_SUPPORT",
    "ELS Phase": "EXTENDED_LIFE_CYCLE_SUPPORT_(ELS)_ADD-ON",
    "ELS URL": "https://access.redhat.com/support/policy/updates/errata"
  },
  "Red Hat OpenShift Container Platform": {
    "Full Support": "FULL_SUPPORT",
    "Maintenance Phase": "MAINTENANCE_SUPPORT",
    "ELS Phase": "EXTENDED_UPDATE_SUPPORT_TERM_2",
    "ELS URL": "https://access.redhat.com/support/policy/updates/openshift"
  },
  "Red Hat Ansible Automation Platform": {
    "Full Support": "FULL_SUPPORT",
    "Maintenance Phase": "MAINTENANCE_SUPPORT_1",
    "ELS Phase": "MAINTENANCE_SUPPORT_2",
    "ELS URL": "https://access.redhat.com/support/policy/updates/ansible-automation-platform"
  }
} as const;
